import React from 'react'
import PriceRowMarginText from '../PriceRowMarginText'

interface Props {
  margin: number
  marginValue: number
  type: 'ao_exact' | 'ao_estimate'
}

function AlwaysOnMarginText(props: Props) {
  const {
    margin,
    marginValue,
    type,
  } = props

  return <PriceRowMarginText
    type={type}
    marginValue={marginValue}
    margin={margin}
  />
}

export default AlwaysOnMarginText
